import { createContext } from 'react';
import { ProposalData } from 'ts/shared/interfaces/ProposalData';

export const EditProposalContext = createContext({
  editMode: false,
  onClickEdit: (index: number) => {},
  onClickDelete: (index: number) => {},
  onClickEditPrice: (index: number) => {},
  proposal: undefined as undefined | ProposalData,
});
